var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "modal-fullscreen1",
      attrs: {
        id: "user-personal-topic-modal",
        size: "lg",
        scrollable: "",
        "no-close-on-backdrop": "",
        "hide-footer": "",
        "hide-header": ""
      }
    },
    [
      _c("confirm-personal-topic", {
        on: {
          saved: function($event) {
            return _vm.closeModal()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aeefe92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aeefe92","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacy/ConfirmPersonalTopicModal.vue
// module id = 1418
// module chunks = 0